import React from 'react';
import {
    AlertTriangle,
    MapPin,
} from 'lucide-react';
import {StatsType} from "../lib/types";

type Props = {
    stats: StatsType
}
export const StatsCard = ({ stats }:Props) => {
    const statItems = [
        {
            icon: <AlertTriangle className="text-red-500" />,
            label: 'Total Incidents',
            value: stats.totalIncidents,
            color: 'text-red-600'
        },
        {
            icon: <MapPin className="text-blue-500" />,
            label: 'Affected Constituencies',
            value: stats.affectedConstituencies,
            color: 'text-blue-600'
        }
    ];

    return (
        <div className="bg-white shadow-lg rounded-lg p-6 w-full">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">Election Incident Overview</h2>
            <div className="grid grid-cols-2 gap-4 w-full">
                {statItems.map((stat, index) => (
                    <div
                        key={index}
                        className="bg-gray-100 rounded-md p-4 flex flex-col items-center space-y-2 hover:shadow-md transition-all"
                    >
                        <div className="mb-2">
                            {stat.icon}
                        </div>
                        <span className="text-sm text-gray-600">{stat.label}</span>
                        <span className={`text-2xl font-bold ${stat.color}`}>
              {stat.value}
            </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

;